define('loadCss',[], () => {
  'use strict';

  const getFileName = function (str) {
    // get the filename from the URL
    const nameWithResourceVersion = str.substring(str.lastIndexOf('/') + 1);
    // remove the resource version
    const nameWithoutResourceVersion = nameWithResourceVersion.substring(0, nameWithResourceVersion.indexOf('.'));
    // remove any possible invalid/unsupported characters from the name
    const name = nameWithoutResourceVersion.replace(/^[^a-z]+|[^\w:.-]+/gi, '');
    return name;
  };

  function loadCss(...params) {
    let callback = null;
    const filesName = params.filter((item) => {
      if (typeof item !== 'function') {
        return true;
      }
      callback = item;
      return false;
    });

    let linksElements = '';
    filesName.forEach((fileName) => {
      const id = getFileName(fileName);
      const url = fileName;
      const rules = document.querySelector('link#' + id);
      if (!rules && fileName && window.resourceDomain) {
        linksElements += `<link rel="stylesheet" href="${url}" id="${id}">`;
      }
    });

    const fragment = document.createRange().createContextualFragment(linksElements);
    const links = fragment.querySelectorAll('link');
    if (links.length > 0) {
      links.forEach((element) => {
        const link = element;
        link.onload = callback;
      });
      document.head.appendChild(fragment);
    }
  }

  return loadCss;
});

